/* Auto-generated by generate-uns-measurements.ts. Do not edit by hand. */
export const GeneratedPhysicalMeasurements = {
  /**
   * Amper
   */
  "Ampere": "A",
  /**
   * Bajti
   */
  "B": "B",
  /**
   * Bar
   */
  "Bar": "bar",
  /**
   * Bit
   */
  "Bit": "bit",
  /**
   * Bajt
   */
  "Byte": "byte",
  /**
   * Stopinje Celzija
   */
  "Celsius": "°C",
  /**
   * Centimeter na sekundo
   */
  "CentiMeterPerSecond": "cm/s",
  /**
   * Kubični meter
   */
  "CubicMeter": "m^3",
  /**
   * Kubični meter na uro
   */
  "CubicMeterPerHour": "m^3/h",
  /**
   * Kubični meter na sekundo
   */
  "CubicMeterPerSecond": "m^3/s",
  /**
   * Dan
   */
  "Day": "day",
  /**
   * Decibel
   */
  "Decibel": "dB",
  /**
   * Stopinja
   */
  "Degree": "°",
  /**
   * Stopinje Fahrenheita
   */
  "Fahrenheit": "°F",
  /**
   * Čevlji
   */
  "Feet": "ft",
  /**
   * Galona
   */
  "Gallon": "gal",
  /**
   * Gigadžul
   */
  "Gigajoule": "GJ",
  /**
   * Gram
   */
  "Gram": "g",
  /**
   * Herc
   */
  "Hertz": "Hz",
  /**
   * Ura
   */
  "Hour": "h",
  /**
   * Džul
   */
  "Joule": "J",
  /**
   * Kelvin
   */
  "Kelvin": "K",
  /**
   * Kiloamper
   */
  "KiloAmpere": "kA",
  /**
   * Kilogram
   */
  "Kilogram": "kg",
  /**
   * Kilodžul
   */
  "Kilojoule": "kJ",
  /**
   * Kilometer
   */
  "KiloMeter": "km",
  /**
   * Kilometer na uro
   */
  "KilometerPerHour": "km/h",
  /**
   * Kilovolt
   */
  "KiloVolt": "kV",
  /**
   * Kilovolt-amper
   */
  "KiloVoltAmpere": "kVA",
  /**
   * Kilovolt-reaktivni amper
   */
  "KiloVoltAmpereReactive": "kVAR",
  /**
   * Kilowatt
   */
  "KiloWatt": "kW",
  /**
   * Kilowattna ura
   */
  "KiloWattHour": "kWh",
  /**
   * Liter
   */
  "Liter": "l",
  /**
   * Megaamper
   */
  "MegaAmpere": "MA",
  /**
   * Megagram na uro
   */
  "MegaGramPerHour": "Mg/h",
  /**
   * Megadžul
   */
  "Megajoule": "MJ",
  /**
   * Megavolt
   */
  "MegaVolt": "MV",
  /**
   * Megavolt-amper
   */
  "MegaVoltAmpere": "MVA",
  /**
   * Megavolt-reaktivni amper
   */
  "MegaVoltAmpereReactive": "MVAR",
  /**
   * Megawatt
   */
  "MegaWatt": "MW",
  /**
   * Megawattna ura
   */
  "MegaWattHour": "MWh",
  /**
   * Meter
   */
  "Meter": "m",
  /**
   * Meter na uro
   */
  "MeterPerHour": "m/h",
  /**
   * Meter na minuto
   */
  "MeterPerMinute": "m/min",
  /**
   * Meter na sekundo
   */
  "MeterPerSecond": "m/s",
  /**
   * Tona
   */
  "MetricTon": "t",
  /**
   * Tona na uro
   */
  "MetricTonPerHour": "t/h",
  /**
   * Miliamper
   */
  "MiliAmpere": "mA",
  /**
   * Miligram
   */
  "Miligram": "mg",
  /**
   * Milidžul
   */
  "Milijoule": "mJ",
  /**
   * Milimeter
   */
  "MiliMeter": "mm",
  /**
   * Milimeter na sekundo
   */
  "MilimeterPerSecond": "mm/s",
  /**
   * Milivolt
   */
  "MiliVolt": "mV",
  /**
   * Milivolt-amper
   */
  "MiliVoltAmpere": "mVA",
  /**
   * Milivolt-reaktivni amper
   */
  "MiliVoltAmpereReactive": "mVAR",
  /**
   * Miliwatt
   */
  "MiliWatt": "mW",
  /**
   * Miliwattna ura
   */
  "MiliWattHour": "mWh",
  /**
   * Minuta
   */
  "Minute": "min",
  /**
   * Njuton
   */
  "Newton": "N",
  /**
   * Brez enote
   */
  "None": "",
  /**
   * Delci na milijardo
   */
  "PartsPerBillion": "ppb",
  /**
   * Delci na milijon
   */
  "PartsPerMillion": "ppm",
  /**
   * Delci na trilijon
   */
  "PartsPerTrillion": "ppt",
  /**
   * Pascal
   */
  "Pascal": "Pa",
  /**
   * Odstotek
   */
  "Percent": "percent",
  /**
   * Funt na kvadratni palec
   */
  "Psi": "psi",
  /**
   * Radian
   */
  "Radian": "rad",
  /**
   * Obratov na minuto
   */
  "RevolutionsPerMinute": "rpm",
  /**
   * Sekunda
   */
  "Second": "s",
  /**
   * Teradžul
   */
  "Terajoule": "TJ",
  /**
   * Volt
   */
  "Volt": "V",
  /**
   * Volt-amper
   */
  "VoltAmpere": "VA",
  /**
   * Volt-reaktivni amper
   */
  "VoltAmpereReactive": "VAR",
  /**
   * Watt
   */
  "Watt": "W",
  /**
   * Wattna ura
   */
  "WattHour": "Wh",
} as const;

export const GeneratedDataSizeMeasurements = {
  /**
   * Bit
   */
  "Bit": "bit",
  /**
   * Bajt
   */
  "Byte": "B",
  /**
   * Eksabajt
   */
  "ExaByte": "EB",
  /**
   * Gigabajt
   */
  "GigaByte": "GB",
  /**
   * Kilobajt
   */
  "KiloByte": "kB",
  /**
   * Megabajt
   */
  "MegaByte": "MB",
  /**
   * Petabajt
   */
  "PetaByte": "PB",
  /**
   * Terabajt
   */
  "TeraByte": "TB",
  /**
   * Jotabajt
   */
  "YottaByte": "YB",
  /**
   * Zetabajt
   */
  "ZettaByte": "ZB",
} as const;

export const GeneratedCounterMeasurements = {
  /**
   * Giga
   */
  "Giga": "G",
  /**
   * Kilo
   */
  "Kilo": "k",
  /**
   * Mega
   */
  "Mega": "M",
} as const;

export type GeneratedPhysicalMeasurement = typeof GeneratedPhysicalMeasurements[keyof typeof GeneratedPhysicalMeasurements];
export type GeneratedDataSizeMeasurement = typeof GeneratedDataSizeMeasurements[keyof typeof GeneratedDataSizeMeasurements];
export type GeneratedCounterMeasurement = typeof GeneratedCounterMeasurements[keyof typeof GeneratedCounterMeasurements];
export type GeneratedMeasurementUnit = GeneratedPhysicalMeasurement | GeneratedDataSizeMeasurement | GeneratedCounterMeasurement | (string & {});
